import { configData } from "../config";

// Pictures uploaded on the live site after its files were copied here are missing from this
// site's files (/basic/web/files, /basic/web/pictures/<style>), and a few bodies still name the
// Drupal copy's address. The live site keeps the same files under /sites/default/files, so a
// picture that fails to load is tried there once before the placeholder is shown.

const LIVE_FILES = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/default/files/';

// The live site's address of one of this site's (or the Drupal copy's) files, or '' for any other picture
export const liveFileUrl = (src) => {
    let url;
    try {
        url = new URL(src, window.location.href);
    } catch (e) {
        return '';
    }
    const path = url.pathname;
    if (url.origin === window.location.origin) {
        if (path.startsWith('/basic/web/files/')) {
            return LIVE_FILES + path.slice('/basic/web/files/'.length);
        }
        // User pictures in one of Drupal's image styles: /basic/web/pictures/<style>/<file>
        const styled = path.match(/^\/basic\/web\/pictures\/([^/]+)\/([^/]+)$/);
        if (styled) {
            return LIVE_FILES + 'styles/' + styled[1] + '/public/pictures/' + styled[2];
        }
        if (path.startsWith('/basic/web/pictures/')) {
            return LIVE_FILES + 'pictures/' + path.slice('/basic/web/pictures/'.length);
        }
        return '';
    }
    if (url.origin === new URL(configData.DRUPAL_DOMAIN_URL).origin && path.startsWith('/sites/')) {
        return configData.DRUPAL_LIVE_DOMAIN_URL + path;
    }
    return '';
};

// A Drupal body's own file addresses (/sites/...), which this site does not serve, as Body.js shows
// them: pictures (src) and links to files (href) from the live site, which has every file (the
// Drupal copy lacks those added after it was taken, and is not part of go-live)
export const drupalFiles = (html) =>
    String(html || '').replace(/(\s(?:src|href)=["'])\/sites\//g, `$1${configData.DRUPAL_LIVE_DOMAIN_URL}/sites/`);

// Points a picture that failed to load at the live site's copy, once; false when there is none to try
const tryLiveCopy = (img) => {
    const live = img.dataset.liveTried ? '' : liveFileUrl(img.src);
    if (!live) return false;
    img.dataset.liveTried = '1';
    img.src = live;
    return true;
};

// An img onError handler: the live site's copy of the picture first, then the placeholder
export const liveCopyOrPlaceholder = (placeholder) => (event) => {
    const img = event.currentTarget;
    if (!tryLiveCopy(img) && img.src !== placeholder) {
        img.src = placeholder;
    }
};

// The same for a picture with no placeholder (those typed into a page's blocks): the live site's
// copy first, then the picture is hidden, as Body.js does with a body's, so it leaves no empty box
export const liveCopyOrHide = (event) => {
    const img = event.currentTarget;
    if (!tryLiveCopy(img)) {
        img.style.display = 'none';
    }
};
